import { publicApiRequest } from '../../lib/hooks/axios-instance'
import { addTokenToHeaders } from '../../lib/utils/addTokenReq'
import { SubscriptionIncomeResponseType } from '../../types/income.type'

export class IncomeService {
  /**
   * Get Subscription Income
   * @returns Promise<any>
   */
  public async getSubscriptionTotalIncome(token: string) {
    return await (
      await publicApiRequest()
    ).get<SubscriptionIncomeResponseType>(
      'transaction/income/subscription-income-total',
      addTokenToHeaders(token),
    )
  }
}
